export const SET_USER = 'SET_USER';
export const GET_CLAIMS_START = 'START_GET_CLAIMS';
export const GET_CLAIMS_SUCCESS = 'GET_CLAIMS_SUCCESS';
export const GET_CLAIMS_FAILED = 'GET_CLAIMS_FAILED';

export interface whiteLabel {
  referenceId: string;
  logoFile: string;
  message: string;
  email: string;
  phone: string;
  name: string;
}

export interface organizationsArray {
  rootOrganizationCode: string;
  organizationCode: string;
  referenceId: string;
  default: boolean;
}

export interface UserProfileStore {
  role?: string;
  user?: any;
  scope?: string;
  claims?: string[];
  paymentGateway?: string[];
  userRef?: string;
  userType?: string;
  distributor?: string;
  name?: string;
  organizationCode?: string;
  orgCode?: string;
  profileCode?: string;
  loadingClaims?: boolean;
  accessToken?: string;
  error?: unknown;
  salesChannel?: string;
  organizationCategory?: string;
  whiteLabel?: whiteLabel;
  organizationNameEN?: string;
  organizationNameFR?: string;
  rootOrganizationCode?: string;
  organizations?: organizationsArray[];
  featureFlags?: FeatureFlag[];
  dssSellingCodes?: [];
  advisorDetails?: any;
  rootContractType?: string;
  BDM?: string;
  profileType?: string;
  authId?: string;
}

export interface UserClaims {
  userRef?: string;
  userType?: string;
  scope?: string;
  idToken?: string;
}

export interface FeatureFlag {
  name: string;
  value: boolean;
}
